import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { error } from 'pdf-lib';
import { debounceTime, forkJoin, map, Subject } from 'rxjs';
import { CalculateFareModalComponent } from 'src/app/components/slideouts/calculate-fare-modal/calculate-fare-modal.component';
import { BillingStatus, UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { PlacetypesService } from 'src/app/services/core/placetypes/placetypes.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { ModifierCodeService } from 'src/app/services/core/modifier-code/modifier-code.service';
import { PrimaryDiagnosisService } from 'src/app/services/core/primary-diagnosis/primary-diagnosis.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { roundUp, validateFileSize } from 'src/app/utils/common.utils';
import { addressValidator } from 'src/app/utils/custom-validators';
import { sweetAlert } from 'src/app/utils/swal';
import { allowOnlyNumbersValidator, onTimeChange, phoneNumberLengthValidator, timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()
@Component({
  selector: 'app-adjustment-form',
  templateUrl: './adjustment-form.component.html',
  styleUrls: ['./adjustment-form.component.css']
})
export class AdjustmentFormComponent {
  addMemberModalObj = false;
  addonsList: any = [];
  levelOfServiceList: any = [];
  preLevelOfServiceList: any = [];
  memberList: any = [];
  selectedMember: any = '';
  modifierList: any = [];
  newTripForm!: FormGroup;
  eventForm!: FormGroup;
  spaceTypeList: any = [];
  spaceTypeMainList: any = [];
  preSpaceTypeList: any = [];
  preAppointmentTypes: any = {};
  submitted = false;
  tripPurposeList: any = [];
  appointmentTypes: any = [];
  user: any;
  todayDate: any;
  fareDetails:any;
  fareCancelDetails:any;
  tripId: any;
  StandingOrderId: any
  addMember: boolean = false;
  timeZone = timeZone;
  selectedDay: any = [];
  fundingSourceList: any = [];
  preFundingSource: any = {}
  serviceAreaList: any = [];
  memberPageNumber = 1;
  memberSearchPageNumber = 1;
  companies: any
  preCompanies: any
  placetypes: any;
  isWillCall: boolean[] = [];
  private readonly memberSearchSubject = new Subject<string | undefined>();
  memberSearchQuery: any;
  @Output() dataLoaded = new EventEmitter<void>();
  preferedTps: any = [];
  companyList: any = [];
  driverList: any = [];
  vehicleList: any = [];
  events: any = [];
  mapObj: any;
  isFromBilling = false;
  userPermission=UserPermission;
  isDetailModal = false;
  menuSection:any
  cancelTripObj: any;
  preSpaceTypeFares: any = {};
  modifierCodeList:any;
  primaryDiagnosisList:any;

  constructor(
    private fb: FormBuilder,
    private uploadService: UploadService,
    private sharedDataService: SharedDataService,
    private SpaceTypeService: SpaceTypeService,
    private levelOfService: LosService,
    private memberService: MemberService,
    private tripService: TripService,
    private router: Router,
    private appointmentType: AppointmentTypeService,
    private addonService: AddonService,
    private serviceArea: ServiceAreasService,
    private fundingSource: FundingSourceService,
    private activatedRoute: ActivatedRoute,
    private placetypesService: PlacetypesService,
    private companyService: CompanyService,
    private cdr: ChangeDetectorRef,
    private credentialService: CredentialService,
    private billingService: BillingService,
    public permissionService: PermissionService,
    private modifierCodeService : ModifierCodeService,
    private primaryDiagnosisService: PrimaryDiagnosisService,
  ) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state as { section?: string; };
    if (state?.section) {
      this.menuSection = state.section;
    }
  }

  get form() {
    return this.newTripForm.controls;
  }

  get eventsArray() {
    return this.eventForm.get('events') as FormArray;
  }

  get pickUpForm() {
    return this.newTripForm.controls.pickup as FormGroup;
  }

  get dropOffForm() {
    return this.newTripForm.controls.destination as FormGroup;
  }

  get addonsForm(): FormArray {
    return this.newTripForm.get('addons') as FormArray;
  }

  get addonsFormGroups(): FormGroup[] {
    return this.addonsForm.controls as FormGroup[];
  }

  get attachmentForm() {
    return this.newTripForm.get('attachments') as FormArray;
  }

  get attachmentFormGroups(): FormGroup[] {
    return this.attachmentForm.controls as FormGroup[];
  }

  ngOnInit(): void {
    if( this.activatedRoute.snapshot.url[0].path === 'billing'){
      this.isFromBilling = true;
    }
    this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
      if (param && param['id'])
        this.tripId = param['id']
    })

    this.newTripForm = this.createForm();
    this.eventForm = this.createEventForm();
    this.makeCompulsoryCalls();
    this.listenMemberSearch();
    this.getAllMembers();
    this.getModifierCodes();
    this.getPrimaryDiagnosis();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).pipe(untilDestroyed(this)).subscribe(
      ([res1, res2]) => {
        if (res2) {
          this.spaceTypeMainList = res2.filter((spaceType: any) => spaceType.isActive === true);
          this.preSpaceTypeList = this.spaceTypeMainList.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
        if (res1) {
          const activeSpaceTypeLosIds = this.spaceTypeMainList
            .filter((spaceType: any) => spaceType.isActive)
            .map((spaceType: any) => spaceType.los);
          this.levelOfServiceList = res1.filter((los: any) => los.isActive === true);

          this.levelOfServiceList = res1.filter((los: any) => los.isActive && activeSpaceTypeLosIds.includes(los.id)
          );
          this.preLevelOfServiceList = this.levelOfServiceList.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
        this.getUser();
        // Rest API calls here
        this.getServiceArea();
        this.getFundingSource();
        this.getAppointmentTypes();
        this.getAllCompanies();
        this.getPlaceTypes();
        this.getAllAddons();
        this.getCompanyList();


        if (this.tripId && this.isFromBilling) {
          this.getBillingTripDetails();
        }else{
          this.getTripDetails();
        }
        this.getTripEvents();
        this.dataLoaded.emit();
      },
      (error: any) => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getTripDetails() {
    this.tripService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        if (this.tripId) {
          this.getMemberById(data.member)
        }

        if(data.fundingsource){
          this.getFaresByFundingSource(data.fundingsource);
        }

        this.newTripForm.patchValue({
          ...data,
          pickup: data.pickup,
          destination: data.destination,
          additionalPassenger: data.additionalPassenger ?? '',
          driver: data.driver,
          vehicle: data.vehicle,
          association: data.association
        });
        this.fareDetails = data.offeredFare?.breakdown || {};
        this.fareCancelDetails = data.offeredFare?.cancelBreakdown || {};
        this.addAttachment(data.attachments);
        this.onSelectLOS(data.levelOfService);
        this.addAddonsItem(data.addons);
        this.memberSearch(null, data.member);

        this.getCompanyWiseDrives();
        this.getCompanyWiseVehicles();
        this.addListeners();
      }
    })
  }

  getBillingTripDetails() {
    this.billingService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {

        if (this.tripId) {
          this.getMemberById(data.member)
        }

         if(data.fundingsource){
          this.getFaresByFundingSource(data.fundingsource);
        }

        this.newTripForm.patchValue({
          ...data,
          pickup: data.pickup,
          destination: data.destination,
          additionalPassenger: data.additionalPassenger ?? '',
          driver: data.driver,
          vehicle: data.vehicle,
          association: data.association
        });
        this.newTripForm.get('suffix')?.setValue(data.suffix);
        this.fareDetails = data.offeredFare?.breakdown || {};
        this.fareCancelDetails = data.offeredFare?.cancelBreakdown || {};
        this.addAttachment(data.attachments);
        this.onSelectLOS(data.levelOfService);
        this.addAddonsItem(data.addons);
        this.memberSearch(null, data.member);
        this.addListeners();
      }
    })
  }

  getMemberById(id: any) {
    const queryParams = {id: id, isActive: true, limit: 9999 }
    this.memberService.getPickerMembers(queryParams).subscribe((data: any) => {
      if (data && data.results && data.results.length) {
        [this.selectedMember] = data.results;
        if (this.selectedMember && this.selectedMember.prefferedTP) {
          this.preferedTps = this.selectedMember.prefferedTP;
          // if (this.preferedTps && this.preferedTps.length) {
          //   this.getAllCompanies();
          // }
        }
      }
    })
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.todayDate = moment();
        this.newTripForm.patchValue({
          pickup: { time: this.todayDate.toISOString() },
          destination: { time: moment(this.todayDate).add(1, 'hours').toISOString() },
        });
      }

    })
  }

  getAllMembers() {
    const queryParams: any = {
      limit: 10,
      page: this.memberPageNumber,
    }

    if (!this.tripId) {
      queryParams.isActive = true;
    }

    this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.memberList = [...this.memberList, ...data.results];
        this.memberPageNumber += 1;
      }
    })
  }
  getServiceArea() {
    this.serviceArea.getPicker({ isActive: true, limit:9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.serviceAreaList = data.results;
      }
    })
  }

  getFundingSource() {
    this.fundingSource.getPicker({ isActive: true, limit: 9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.fundingSourceList = data.results;
        this.preFundingSource = this.fundingSourceList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getPlaceTypes() {
    this.placetypesService.getPickers({ isActive: true, limit: 9999}).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.placetypes = data.results;
      }
    })
  }

  getLevelOfService() {
    return this.levelOfService.getPicker({ isActive: true, limit: 9999 }).pipe(
      map((res: any) => res.results || [])
    );
  }

  getSpaceTypeList() {
    return this.SpaceTypeService.getPicker({ isActive: true, limit: 9999 }).pipe(
      map((res: any) => res.results || [])
    );
  }

  getCompanyList() {
    this.credentialService.getPicker({ isActive: true, isApproved:true, limit: 9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.companyList = data.results || [];
      }
    })
  }
  getCompanyWiseDrives() {
    let queryParams = {
      company: this.newTripForm.value.company,
      limit: 9999,
      isActive: true,
      isApproved: true
    }
    this.credentialService.getPickerDrivers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.driverList = data.results;
      }
    })
  }
  getCompanyWiseVehicles() {
    let queryParams = {
      company: this.newTripForm.value.company,
      limit: 9999,
      isActive: true,
      isApproved:true
    }
    this.credentialService.getPickerVehicles(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.vehicleList = data.results;
      }
    })
  }

  getTripEvents() {
    const queryParam:any = {
      limit: 9999
    }
    if (this.isFromBilling) {
      queryParam.billing= this.tripId;
    } else{
      queryParam.trip= this.tripId;
    }

    this.tripService.getPickerTripEvents(queryParam)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.events = data.results.sort(
            (a: any, b: any) => new Date(a.time).getTime() - new Date(b.time).getTime()
          );

          // Build FormArray dynamically
          const eventFGs = this.events.map((e: any) =>
            this.fb.group({
              status: [e.status],
              trip: [e.trip],
              latitude: [e.latitude],
              longitude: [e.longitude],
              time: [e.time],
              company:[e.company],
              id:[e.id]
            })
          );

          const eventFormArray = this.fb.array(eventFGs);
          this.eventForm.setControl('events', eventFormArray);

        }
      });
  }

  sortEventsByTime() {
    const sorted = this.eventsArray.value.sort(
      (a: any, b: any) => new Date(a.time).getTime() - new Date(b.time).getTime()
    );
    this.eventsArray.clear();
    sorted.forEach((evt: any) => {
      this.eventsArray.push(this.fb.group(evt));
    });
  }


  getAllAddons() {
    const queryParams = {
      status: true,
      limit: 999,
    }
    this.addonService.getPickerAddons(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.addonsList = data.results.filter((addons: any) => addons.isActive === true);

      }
    })
  }


  onAdjustTrip() {
    this.submitted = true;
    if (this.newTripForm.invalid) return;
    
    const payload = this.newTripForm.value;
   
    if (payload.pickup.phoneNumber === '') {
      delete payload.pickup.phoneNumber
    }
    if (payload.destination.phoneNumber === '') {
      delete payload.destination.phoneNumber
    }
    if (payload.serviceArea === '') {
      delete payload.serviceArea
      }

    if (this.isFromBilling) {
      payload.billingStatus = BillingStatus.RESUBMIT
    }

    // if (this.isFromBilling){
    //   payload.billing = this.tripId
    // }else{
    //   payload.trip = this.tripId
    // }
    // const events = this.eventForm.value.events;
    // if(this.isFromBilling){
    //   payload.billing = this.tripId
    //   delete payload.trip
    // }


  if (!payload.company || payload.company === "null") {
      payload.company = null
    }

    if (!payload.vehicle || payload.vehicle === "null") {
      payload.vehicle = null
    }
    
    if (!payload.driver || payload.driver === "null") {
      payload.driver = null
    }
 
    if (!payload.fare || payload.fare === "null") {
      payload.fare = null
    }
    
    if (!payload.offeredFare || payload.offeredFare === "null") {
      payload.offeredFare = null
    }

    if (!this.isFromBilling) {
      payload.trip = this.tripId
    }
    this.billingService.adjustTrip(payload, this.isFromBilling, this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.id) {
        const events = this.eventForm.value.events.map((event: any) => ({ ...event, trip: payload.trip, billing: data.id,company: payload.company}));
        this.billingService.bulkAdjustEvents(events).pipe(untilDestroyed(this)).subscribe((res: any) => {
          if (res) {
            if(!this.isFromBilling){
            this.router.navigate(['trips'], { fragment: this.menuSection === 'all' ? this.menuSection : data.status });
            }else{
              this.router.navigateByUrl('billing/vendor');
            }
          }
        });
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    }
    );
  }


  onSelectLOS(losId: any) {
    if (!losId) {
      this.spaceTypeList = [];
      this.newTripForm.patchValue({ spaceType: '' });
      return;
    }
    this.spaceTypeList = this.spaceTypeMainList.filter((item: any) => item.los === losId);
    if (!this.spaceTypeList.some((item: any) => item.id === this.newTripForm.value.spaceType)) {
      this.newTripForm.patchValue({ spaceType: '' });
    }
  }

  onSelectFundingSource(evt: any) {
    if (evt) {
      this.getFaresByFundingSource(evt);
    }
  }

  onSelectMember(event: any) {
    if (typeof event === 'string') {
      this.selectedMember = event ? this.memberList.find((m: any) => m.id === event) : null;
      this.preferedTps = this.selectedMember.prefferedTP
      // if (this.preferedTps && this.preferedTps.length) {
      //   this.getAllCompanies();
      // }
    } else {
      this.selectedMember = event ? this.memberList.find((m: any) => m.id === event.id) : null;
    }
    if (!this.selectedMember) {
      this.clearMemberData();
      return;
    }
    const memberFundingSourceId = (this.selectedMember.fundingSource ? this.selectedMember?.fundingSource : this.selectedMember.fundingsource) || ''
    if (this.selectedMember) {
      this.newTripForm.patchValue({
        ...this.selectedMember,
        fundingsource: memberFundingSourceId,
        pickup: {
          phoneNumber: this.selectedMember.contactNumber,
          address: this.selectedMember.address
        }
      })
      const matchedServiceArea = this.serviceAreaList?.find((area: any) => {
        return area.zipCodes.includes(this.selectedMember?.address?.zipCode);
      });
      this.newTripForm.patchValue({
        serviceArea: matchedServiceArea ? matchedServiceArea.id : ''
      });
      this.onSelectLOS(this.selectedMember.levelOfService)
    } else {
      this.newTripForm.patchValue({
        member: '',
        pickup: {
          time: '',
          placeName: '',
          phoneNumber: '',
          address: {
            name: '',
            coords: '',
            city: '',
            state: '',
            zipCode: '',
            floor: '',
            aptSuiteRoom: '',
          }
        },
        appointmentType: '',
        levelOfService: '',
        spaceType: '',
        privateNotes: '',
        generalNotes: '',
        billingNotes: '',
      });
    }
  }

  clearMemberData() {
    this.newTripForm.patchValue({
      member: '',
      fundingsource: '',
      serviceArea: '',
      pickup: {
        placeName: '',
        phoneNumber: '',
        address: {
          name: '',
          coords: '',
          city: '',
          state: '',
          zipCode: '',
          floor: '',
          aptSuiteRoom: '',
        }
      },
      appointmentType: '',
      levelOfService: '',
      spaceType: '',
      privateNotes: '',
      generalNotes: '',
      billingNotes: '',
    });
    this.selectedMember = null;
  }


  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null);
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onSelectAddonItem(addonItem: any) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find((item: any) => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  quantityGreaterThanZero(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const numberValue = Number(value);
    return numberValue > 0 ? null : { greaterThanZero: true };
  }


  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addons') as FormArray;
    items.removeAt(index);
  }

  addAddonsItem(preAddonList?: any) {
    const items = this.newTripForm.get('addons') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addon: [addon.addon, Validators.required],
            quantity: [addon.quantity, [Validators.required, this.quantityGreaterThanZero]],
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addon: ['', Validators.required],
        quantity: [1, [Validators.required, this.quantityGreaterThanZero]],
      })
    );
    // }
  }

  createForm(): FormGroup {
    return this.fb.group({
      member: ['', Validators.required],
      primaryDiagnosis:[''],
      pickup: this.fb.group({
        time: ['', Validators.required],
        placeName: [''],
        phoneNumber: ['', [phoneNumberLengthValidator]],
        address: this.fb.group({
          name: ['', Validators.required],
          coords: [[]],
          city: [''],
          state: [''],
          zipCode: [''],
          floor: [''],
          aptSuiteRoom: [''],
        }, { validators: addressValidator() }),
        modifier: [''],
      },{ validators: allowOnlyNumbersValidator('phoneNumber')}),
      destination: this.fb.group({
        time: ['', Validators.required],
        placeName: [''],
        phoneNumber: ['', [phoneNumberLengthValidator]],
        address: this.fb.group({
          name: ['', Validators.required],
          coords: [[]],
          city: [''],
          state: [''],
          zipCode: [''],
          floor: [''],
          aptSuiteRoom: [''],
        }, { validators: addressValidator() }),
        modifier: [''],
      },{ validators: allowOnlyNumbersValidator('phoneNumber')}),
      appointmentType: [''],
      levelOfService: ['', Validators.required],
      spaceType: ['', Validators.required],
      miles: [''],
      additionalPassenger: [''],
      privateNotes: [''],
      generalNotes: [''],
      billingNotes: [''],
      requesterName: [''],
      attachments: this.fb.array([]),
      reference: [''],
      suffix: [''],
      addons: this.fb.array([]),
      fundingsource: ['', Validators.required],
      serviceArea: ['', Validators.required],
      company: [null],
      driver: [null],
      vehicle: [null],
      distance: [''],
      duration: [''],
      trip: [''],
      status: [''],
      fare: [null],
      offeredFare: [null],
      preSpecialRate: [''],
      specialRate: [''],
      association: [''],
      signature: [''],
      flags: [{}],
      changeReasonNotes: [''],
      isBillable:[false],
      isNoShow:[false]
    });
  }

  createEventForm(): FormGroup {
    return this.fb.group({
      events: this.fb.array([]),
    });
  }


  setOriginAddress(place: any, index?: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';
    const matchedServiceArea = this.serviceAreaList?.find((area: any) => {
      return area.zipCodes.includes(zip);
    });
    if (index != 0) {
      console.log('matchedServiceArea', matchedServiceArea);
      this.newTripForm.patchValue({
        serviceArea: matchedServiceArea ? matchedServiceArea.id : ''
      });
    }
    this.newTripForm.patchValue({
      pickup: {
        address: {
          city: cityName,
          state: stateName,
          zipCode: zip,
          name: place.formatted_address,
          coords: [
            place.geometry.location.lng(),
            place.geometry.location.lat()
          ]
        }
      }
    });
    this.calculateMiles(index);
  }

  setDestinationAddress(place: any, index?: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    // const zip = selectedAddress.zipCode;
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';


    this.newTripForm.patchValue({
      destination: {
        address: {
          city: cityName,
          state: stateName,
          zipCode: zip,
          name: place.formatted_address,
          coords: [
            place.geometry.location.lng(),
            place.geometry.location.lat()
          ]
        }
      }
    });
    this.calculateMiles(index);
  }

  onPickupDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
    this.newTripForm.patchValue({
      destination: {
        time: moment(controlName?.value).add(1, 'hour').toISOString()
      }
    })
  }

  jobAcceptedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobArrivedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobStartedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobCompletedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobFinishedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobCancelledDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  getAppointmentTypes() {
    this.appointmentType.getPicker({ isActive: true, limit: 999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.appointmentTypes = data.results
        this.preAppointmentTypes = this.appointmentTypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getAllCompanies() {
    let queryParams = {
      limit: 9999,
    }

    this.companyService.getPickerCompanies(queryParams)
      .subscribe((data: any) => {
        if (data && data.results) {
          this.companies = data.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  addAttachment(preAttachments?: any) {
    const attachments = this.newTripForm.get('attachments') as FormArray;
    if (preAttachments) {
      for (const attachment of preAttachments) {
        attachments.push(
          this.fb.group({
            filename: [attachment.filename, Validators.required],
            url: [attachment.url, Validators.required],
            mimeType: [attachment.mimeType],
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    attachments.push(
      this.fb.group({
        filename: ['', Validators.required],
        url: ['', Validators.required],
        mimetype: [''],
      })
    );
  }

  uploadAttachment(event: any) {
    const fileInput = event.target
    const file = fileInput.files?.[0];

    if (!validateFileSize(file)) {
          return;
        }

    this.uploadService.uploadTripAttachment(event.target.files[0]).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        const file = event.target.files[0];
        if (file) {
          const fileData = {
            filename: file.name,
            mimeType: file.type,
            url: data.fileUrl
          };
          this.attachmentForm.push(this.fb.control(fileData));
        }
        fileInput.value = '';
      }
    })
  }

  removeAttachment(index: number) {
    this.attachmentForm.removeAt(index);
  }

  isAddressInvalid(nameControl: AbstractControl | null, coordsControl: AbstractControl | null): boolean {
    const nameInvalid = !!nameControl?.errors?.['required'];
    const coords = coordsControl?.value;

    const coordsInvalid =
      !coords || // null, undefined, or empty string
      (Array.isArray(coords) && coords.length === 0) || // empty array
      (typeof coords === 'object' && !Array.isArray(coords) && Object.keys(coords).length === 0); // empty object

    return nameInvalid || coordsInvalid;
  }



  openAddMemberModal() {
    this.addMember = true;
  }

  onSaveMember(evt: any) {
    if (evt && this.memberList && this.memberList.length) {
      // Update existing member in the list
      const index = this.memberList.findIndex((member: any) => member.id === evt.id);
      if (index !== -1) {
        this.memberList[index] = evt; // Update existing member
        this.memberList = [...this.memberList];
      } else {
        this.memberList.push(evt); // Add new member if not exists (fallback)
      }

      // Update the form with new member details
      this.newTripForm.patchValue({
        member: evt.id
      });
      this.onSelectMember(evt);

      this.addMemberModalObj = false;

      // Refresh the dropdown by triggering change detection
    }


  }


  calculateMiles(index?: number) {
    let queryParam;
    let startCoords: any = [];
    let endCoords: any = [];

    startCoords = this.pickUpForm.value.address.coords;
    endCoords = this.dropOffForm.value.address.coords;

    if (startCoords.length && endCoords.length) {
      queryParam = {
        start: [startCoords[0], startCoords[1]].toString(),
        end: [endCoords[0], endCoords[1]].toString(),
      };

      this.tripService
        .calculateMiles(queryParam)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.cdr.detectChanges();
              const firstSegment =
                data.features[0]?.properties?.segments[0]?.distance || 0;
              const milesValue = Number((firstSegment / 1609.344).toFixed(2));
              this.newTripForm.patchValue({ miles: roundUp(milesValue) });
            }
          },
          error: (err) => {
            this.cdr.detectChanges();
            sweetAlert('Error', 'Invalid Address', 'error', 'Ok');
          },
          complete: () => {
            // optional: code to run after the observable completes
          },
        });
    }
  }


  onScroll() {
    if (this.memberSearchQuery) {
      this.memberSearch(this.memberSearchQuery);
    } else {
      this.getAllMembers();
    }
  }

  onSearch(event: any) {
    const { term } = event;
    if (term) {
      this.memberSearchSubject.next(term);
    } else {
      this.clearSearh();
    }
  }

  listenMemberSearch() {
    this.memberSearchSubject
      .pipe(debounceTime(1000))
      .pipe(untilDestroyed(this)).subscribe((search) => {
        this.memberSearchQuery = search;
        if (search && search.length >= 3) {
          this.memberList = [];
          this.memberSearchPageNumber = 1;
          this.memberSearch(search);
        }
      });
  }

  memberSearch(search: any, id = null) {
    const queryParams: any = {
      limit: 10,
      page: this.memberSearchPageNumber
    }

    if (search) {
      queryParams.search = search;
    }

    if (id) {
      queryParams.id = id;
    }

    if (!this.tripId) {
      queryParams.isActive = true;
    }

    this.memberService.searchMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.memberList = [...this.memberList, ...data.results];
        this.memberSearchPageNumber += 1;
      }
    });
  }


  setWillCall(event: any, index: number) {

    if (event.target.checked) {
      // Trigger UI refresh for checkbox binding
      this.isWillCall = [...this.isWillCall];
    } else {
      // Only uncheck current one
      this.isWillCall[index] = false;
      this.isWillCall = [...this.isWillCall];
    }
  }

  onClear() {
    if (this.memberSearchQuery) {
      this.clearSearh();
      this.clearMemberData();
    }
  }

 openMapModal(event?: any) {
    const hasData = event && typeof event === 'object' && Object.keys(event).length > 0;

    this.mapObj = hasData
      ? event
      : {
        company: this.newTripForm.value.company || '',
        latitude: 40.7128,
        longitude: -74.0060,
        status: '',
        trip: this.tripId || '',
        time: moment().toISOString(),
      };

  }


 onLocationChanged(locationData:any) {
    if (locationData) {
      const eventIndex = this.eventsArray.value.findIndex((event: any) =>
        event.status === locationData.status 
      );

      if (eventIndex !== -1) {
        // Update existing event
        const eventControl = this.eventsArray.at(eventIndex);
        if (eventControl) {
          eventControl.patchValue({...locationData
          });
          this.events[eventIndex] = locationData;
          this.cdr.detectChanges();
        }
      } else {
        // Add new event
        const newEvent = {
          ...locationData,
          company: this.mapObj.company
        };
        this.eventsArray.push(this.fb.group(newEvent));
        this.cdr.detectChanges();
      }
       this.sortEventsByTime();
    }
  }

  clearSearh() {
    this.memberSearchQuery = '';
    this.memberSearchPageNumber = 1;
    this.memberList = [];
    this.memberPageNumber = 1
    this.getAllMembers();
  }

  onClose() {
    if (!this.selectedMember && this.memberSearchQuery) {
      this.clearSearh();
    }
  }

  opendetailModal() {
    this.isDetailModal = true;
  }

  loadAllDrivers() {
    this.newTripForm.patchValue({ driver: '', vehicle: '', offeredFare: {} });
    this.getCompanyWiseDrives();
    this.getCompanyWiseVehicles();
  }

  addListeners() {
    const watchFareControls = (controls: AbstractControl[]) => {
      controls.forEach(control => {
        control.valueChanges
          .pipe(
            debounceTime(500),
            untilDestroyed(this)
          )
          .subscribe(() => {
            const parent = control.parent as FormGroup;
            if (!parent) return;

            const controlName = Object.keys(parent.controls)
              .find(name => control === parent.controls[name]);

            if (!controlName) return;

            if (controlName === 'miles') {
              const milesValue = Number(control.value);
              if (isNaN(milesValue) || milesValue < 0) return;
            }
            if (controlName === 'addons') {
              const addons = control.value.filter((item: any) => item.addon)
              if (!addons.length) return;
            }
            this.fareEstimation()
          });
      });
    };

    watchFareControls(
      [
        this.newTripForm.get('company'),
        this.newTripForm.get('spaceType'),
        this.newTripForm.get('levelOfService'),
        this.pickUpForm.get('pickup.address.coords'),
        this.newTripForm.get('destination.address.coords'),
        this.newTripForm.get('miles'),
        this.newTripForm.get('addons'),
        this.newTripForm.get('pickup.time'),
      ].filter((c): c is AbstractControl => c !== null)
    );
  }

  fareEstimation() {
    const companyValue = this.newTripForm.get('company')?.value;
    const pickupCoords = this.pickUpForm.get('address')?.value?.coords;
    const destCoords = this.newTripForm.get('destination')?.value?.address?.coords;
    const levelOfService = this.newTripForm.get('levelOfService')?.value;
    const spaceType = this.newTripForm.get('spaceType')?.value;

    // ✅ If any required values are missing, don't call API.
    if (!pickupCoords || pickupCoords.length < 2 || !destCoords || destCoords.length < 2 || !companyValue || !levelOfService || !spaceType) {
      this.fareDetails = null;
      this.fareCancelDetails = null;
      return;
    }
    let addons = this.newTripForm.value.addons.filter((item: any) => item.addon)

    const trip: any = {
      pickup: { time: this.newTripForm.get('pickup')?.value?.time, address: { coords: pickupCoords } },
      destination: { address: { coords: destCoords } },
      levelOfService: levelOfService || null,
      spaceType: spaceType || null,
      addons: addons
    };
    const miles = parseFloat(this.newTripForm.value.miles);
    if (!isNaN(miles) && miles >= 0) {
      trip.miles = miles;
    }

    // if (addons && addons.length) {
    //   trip.addons = addons;
    // }

    const payload: any = {
      trips: [trip],
      company: companyValue || null,
    };

    this.tripService.calculateFare(payload).subscribe({
      next: (response: any) => {
        const fareEstimation = response[0] || {};
        this.fareDetails = fareEstimation?.breakdown || {};
        this.fareCancelDetails = fareEstimation?.cancelBreakdown || {};
        if(this.fareDetails.total)
        this.newTripForm.patchValue({ offeredFare: fareEstimation});
      },
      error: () => {
        sweetAlert('Error', 'Failed to calculate fare', 'error', 'Ok');
      },
    });
  }

  formatValue(value: any) {
    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'object' && value !== null) {
      return `Rate: ${value.fare ?? 'N/A'} From: ${value.from ?? ''} To: ${value.to ?? ''}`;
    } else {
      return 'N/A';
    }
  }

  grandTotal(legA: any): number {
    const legATotal = Number(legA?.total || 0);
    return legATotal;
  }

   onDeleteEvent(event:any,index: number) {
    sweetAlert('Warning', 'Are you sure you want to delete this event ?', 'warning', 'Yes', 'No').then((result) => {
      if (result.isConfirmed) {
        const events = this.eventForm.get('events') as FormArray;
        events.removeAt(index);
        this.events.splice(index, 1);

        if(this.isFromBilling) {
          this.tripService.deleteBillingEvents(event.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
            if (data) {
              sweetAlert('Success', 'Event deleted successfully', 'success', 'OK');
            }
          })
        }
      }
  
  })
  }

  onChangeStatus(event:any){
    this.newTripForm.patchValue({status: event.target.value});
    if(event.target.value === 'completed'){
      this.newTripForm.patchValue({changeReasonNotes: '', flags: {...this.newTripForm.value.flags ,isBillable: false, isNoShow: false} });
    }
  }

  openCancelReasonModal(){
    this.cancelTripObj = this.newTripForm.value;
  }

  onCancelTrip(event:any){
    this.newTripForm.patchValue({changeReasonNotes: event.changeReasonNotes, flags: {...this.newTripForm.value.flags ,isBillable: event.isBillable, isNoShow: event.isNoShow} });
  }

   onChangeOriginAddress() {
    this.newTripForm.patchValue({
      pickup: {
        address: {
          coords: '',
          city: '',
          state: '',
          zipCode: '',
        }
      }
    });
  }

  onChangeDestinationAddress() {
    this.newTripForm.patchValue({
      destination: {
        address: {
          coords: '',
          city: '',
          state: '',
          zipCode: '',
        }
      }
    });
  }

    getFaresByFundingSource(fundingSourceId: string) {
    this.preSpaceTypeFares = {};
    this.credentialService.getfundingSourceFares(fundingSourceId, { limit: 9999, isActive: true }).subscribe((res: any) => {
      this.preSpaceTypeFares = (res?.results || []).reduce((obj: any, item: any) => {
        obj[item.spaceType] = item;
        return obj;
      }, {});
    }, (err: any) => {
      sweetAlert('Error', err, 'error', 'Ok');
    });
  }


  getModifierCodes() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.modifierCodeService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.modifierCodeList = data.results;
        }
      })
  }

   getPrimaryDiagnosis() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.primaryDiagnosisService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.primaryDiagnosisList = data.results;
        }
      })
  }
}
